import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Divider from '../../components/Divider/Divider';
import PageTitle from '../../components/PageTitle/PageTitle';
import './History.css'


const History = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/history.json`);
    const {
        breadcrumb,
        selectedPage,
        breadCrumbImage,
        pageTitle,
        pageSubtitle,
        content,
        contentStart,
        contentEnd,
        contentQuote,
        ceoQuote
    } = data

    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                classColor='white100'
                image={breadCrumbImage}

            />
            <div className='main-container mg-top-100 mg-bot-100'>
                <section className="section-container">
                    <PageTitle title={pageTitle} subtitle={pageSubtitle} />
                    <span dangerouslySetInnerHTML={{ __html:contentStart }}></span>
                    <span className='text-quote'>{contentQuote}</span>
                    <div className='divider-quote'>
                        <Divider width={'570px'} />
                        <span className='quote'>{ceoQuote}</span>
                    </div>
                    <span dangerouslySetInnerHTML={{ __html:contentEnd }}></span>
                </section>
            </div>
        </>

    )
}

export default History;